import DesktopPriceSection from './DesktopPriceSection';

export default DesktopPriceSection;
